import { useEffect, useState } from "react";
import { getAttachedDPAction } from "./API/Action";
import { toast } from "react-toastify";
import { Box, Typography } from "@mui/material";
import GlassModal from "../../v2/MUI_custom_component/Modal/GlassModal";
import AttachedDPList from "./Components/AttachedDPList";

const ViewAttachedDP = ({ onClose, open, poDetails }) => {
    const [attachedDPData, setAttachedDPData] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const fetchAttachedDP = async () => {
        if (!poDetails?.humbee_po_number) return;

        const config = new URLSearchParams();
        config.append('order_booking_id', poDetails.humbee_po_number);
        setLoading(true);
        const {data, error, message} = await getAttachedDPAction(config);
        setLoading(false);
        if(!error){
            setAttachedDPData(data);
        }else{
            toast.error(message);
        }
    };
    
    useEffect(() => {
        if (open && poDetails) {
            fetchAttachedDP();
        }
    }, [open, poDetails]);

  return (
    <GlassModal
        open={open}
        onClose={onClose}
        title="Attached DP"
        scrollable={true}
        maxWidth="800px"
        zIndex={2}
    >
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: {xs: 4, md: 0}}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Typography variant="labelD" sx={{ color: '#666' }}>
                        User PO No :
                    </Typography>
                    <Typography variant="body1">
                        {poDetails.humbee_po_number || '-'}
                    </Typography>
                </Box>
                <AttachedDPList 
                    attachedDPData={attachedDPData} 
                    loading={loading} 
                />
            </Box>
        </Box>
    </GlassModal>
  )
}

export default ViewAttachedDP